module.exports = __webpack_public_path__ + "media/34.1435ed13.mp3";